import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { makeStyles } from '@material-ui/core/styles';
import EChargesDetail from './eChargesDetail';

const useStyles = makeStyles((theme) => ({
    customTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginRight: '3px',
      borderRadius: '3px',
      '&.Mui-selected': {
        backgroundColor: 'transparent',
        color: 'black', 
        border: `1px solid ${theme.palette.primary.main}`,
      },
      printerTab: {
        backgroundColor: '#1F4A7C',
        color: 'white',
        marginLeft: '200px',
        borderRadius: '2px',
      },
      printerIcon: {
        verticalAlign: 'middle',
        marginLeft: '5px',
      },
    },
  }));

function EChargesReport() {
    const classes = useStyles()
    const [selectedTabIndex, setSelectedTabIndex] = useState('1');
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
  
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', marginLeft: '20px' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example" defaultIndex={selectedTabIndex}>
                        <Tab label="E-Charges" value="1" className={classes.customTab}/>
                    </TabList>
                </Box>
                <TabPanel value="1">
                    <EChargesDetail />
                </TabPanel>
            </TabContext>
        </Box>
    );
}

export default EChargesReport